export default __webpack_public_path__ + "static/media/Resume.21838219.pdf";